import React, { Component } from "react";

import sudhirPic from "../home01/Images/sudhirLinkedIn.jpeg"
import ajayPic from "../home01/Images/ajayLinkedIn.jpeg"
import bhaveshPic from "../home01/Images/bhaveshLinkedIn.jpeg"
import shrawaniPic from "../home01/Images/shrawaniLinkedIn.jpeg"
import vaibavPic from "../home01/Images/vaibavLinkedin.jpeg"
class Testimonial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testimonial: [
        {
          id: 1,
          img: sudhirPic,
          alt: "images",
          text01:"We have worked together on a project at Cricbuzz. He does efficient coding. He is ",
          text02:"good at Student Data Structure and advanced javascript.",
          text03: "It's been a great experience working with him.",
          name: "Sudhir Chavhan",
          classname: "testimonial-t1 text-center",
          href:"https://www.linkedin.com/in/suman-giri-/details/recommendations/?detailScreenTabIndex=0"
        },
        {
          id: 2,
          img: bhaveshPic,
          alt: "images",
          text01:"I recommend Suman Giri. He has good skills in Full stack development, leadership, teamwork, and",
          text02:"  good problem-solving skills. He always shows dedication and enthusiasm toward ",
          text03: "  his work. He never hesitates to help people out.",
          name: "Bhavesh Chavhan",
          classname: "testimonial-t1 text-center",
          href:"https://www.linkedin.com/in/suman-giri-/details/recommendations/?detailScreenTabIndex=0"
        },
        {
          id: 3,
          img: vaibavPic,
          alt: "images",
          text01:"Ability to debug any problem is Suman's priority, he has great problem ",
          text02:"solving skills with deep knowledge.",
          text03: "in Express.js mongoDB and React",
          name: "Vibhav kumar Mishra",
          classname: "testimonial-t1 text-center",
          href:"https://www.linkedin.com/in/suman-giri-/details/recommendations/?detailScreenTabIndex=0"
        },
        {
          id: 4,
          img: ajayPic,
          alt: "images",
          text01:"Suman Giri is good in problem solving as well as frontend ",
          text02:"and backend and he is good in communication",
          text03: " and friendly in behaviour.",
          name: "Ajay Kumar Maurya",
          classname: "testimonial-t1 text-center",
          href:"https://www.linkedin.com/in/suman-giri-/details/recommendations/?detailScreenTabIndex=0"
        },
        {
          id: 5,
          img: shrawaniPic,
          alt: "images",
          text01:"Suman is a good Front-end as well as Back-end Developer and good at technologies like Javascript, ",
          text02:"HTML, CSS, etc. He is also good at Data structures and Algorithms.",
          text03: " He is well organized and a fast learner.",
          name: "Shrawani Nilange",
          classname: "testimonial-t1 text-center",
          href:"https://www.linkedin.com/in/suman-giri-/details/recommendations/?detailScreenTabIndex=0"
        },
      ],
    };
  }
  render() {
    return (
      <div className="container">
        <div className="custom-dot dot-t1 dot-s1 none-nav-default mg-dots-s1">
          <div
            className="flat-carousel-box data-effect clearfix"
            data-gap={0}
            data-column={1}
            data-column2={1}
            data-column3={1}
            data-column4={1}
            data-column5={1}
            data-dots="true"
            data-auto="false"
            data-nav="false"
            data-loop="true"
          >
            <div className="owl-carousel">
              {this.state.testimonial.map((data) => (
                <a href={data.href} target="_blank" rel="noreferrer" className={data.classname} key={data.id}>
                  <div className="avatar mg-b29">
                    <img src={data.img} alt={data.alt} />
                  </div>
                  <p className="lt-sp03 mg-b25">
                    {data.text01}
                    <br /> {data.text02} <br />
                    {data.text03}
                  </p>
                  <h3 className="name f-w600">{data.name}</h3>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;
